"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _config = require("./config");
var _skeletonTheme = require("./skeleton-theme");
var _excluded = ["dataTestId", "height", "width", "margin", "lineHeight", "noBorderRadius", "size", "variant"];
/* eslint react/prop-types: 0 */
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function StyledSkeleton(props) {
  var dataTestId = props.dataTestId,
    height = props.height,
    width = props.width,
    margin = props.margin,
    lineHeight = props.lineHeight,
    noBorderRadius = props.noBorderRadius,
    size = props.size,
    variant = props.variant,
    rest = _objectWithoutProperties(props, _excluded);
  var skeletonTheme = _react["default"].useContext(_skeletonTheme.SkeletonContext);
  var skeletonColors = (0, _config.calculateColours)(skeletonTheme === null || skeletonTheme === void 0 ? void 0 : skeletonTheme.color);
  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    $height: height,
    $width: width,
    $lineHeight: lineHeight,
    $margin: margin,
    $noBorderRadius: noBorderRadius,
    $size: size,
    $variant: variant,
    "data-testid": dataTestId,
    theme: skeletonColors
  }, rest));
}
var _default = exports["default"] = StyledSkeleton;
var Container = _styledComponents["default"].div.attrs(function (props) {
  return {
    className: "fuse-skeleton-".concat(props.$variant),
    'aria-hidden': true
  };
}).withConfig({
  displayName: "styled-skeleton__Container",
  componentId: "sc-1iv4mp1-0"
})(["position:relative;overflow:hidden;cursor:wait;border-radius:", ";border-radius:", ";transform:translateZ(0);background-color:", ";", " ", " ", " ", " ", " @media screen and (prefers-reduced-motion:no-preference){@keyframes skeletonPulseAnimation{0%{opacity:0;}50%{opacity:1;}100%{opacity:0;}}&:before{height:100%;position:absolute;top:0;right:0;bottom:0;left:0;background-color:", ";animation:skeletonPulseAnimation 2.4s infinite;animation-timing-function:ease-in-out;content:'';}}"], function (_ref) {
  var $variant = _ref.$variant;
  return $variant === 'circle' ? '50%' : '4px';
}, function (_ref2) {
  var $noBorderRadius = _ref2.$noBorderRadius;
  return $noBorderRadius && '0';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "var(--color-global-".concat(theme.color, ")");
}, function (_ref4) {
  var _defaultConfig$rect$h, _defaultConfig$rect$h2, _defaultConfig$rect$h3;
  var $variant = _ref4.$variant,
    $height = _ref4.$height;
  return $variant === 'rect' && "\n\theight: ".concat($height !== null && $height !== void 0 && $height.s ? $height.s : (_defaultConfig$rect$h = _config.defaultConfig.rect.height) === null || _defaultConfig$rect$h === void 0 ? void 0 : _defaultConfig$rect$h.s, ";\n    @media all and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n        height: ").concat($height !== null && $height !== void 0 && $height.m ? $height.m : ($height === null || $height === void 0 ? void 0 : $height.s) || ((_defaultConfig$rect$h2 = _config.defaultConfig.rect.height) === null || _defaultConfig$rect$h2 === void 0 ? void 0 : _defaultConfig$rect$h2.s), ";\n      }\n    @media all and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n        height: ").concat($height !== null && $height !== void 0 && $height.l ? $height.l : ($height === null || $height === void 0 ? void 0 : $height.s) || ((_defaultConfig$rect$h3 = _config.defaultConfig.rect.height) === null || _defaultConfig$rect$h3 === void 0 ? void 0 : _defaultConfig$rect$h3.s), ";\n      }\n  ");
}, function (_ref5) {
  var $variant = _ref5.$variant,
    $lineHeight = _ref5.$lineHeight;
  return $variant === 'text' && "\n    height: var(--font-line-height-".concat($lineHeight || _config.defaultConfig.text.lineHeight, ");\n  ");
}, function (_ref6) {
  var $variant = _ref6.$variant,
    $size = _ref6.$size;
  return $variant === 'circle' && "\n    height: ".concat($size || _config.defaultConfig.circle.size, ";\n    width: ").concat($size || _config.defaultConfig.circle.size, ";\n    min-height: ").concat($size || _config.defaultConfig.circle.size, ";\n    min-width: ").concat($size || _config.defaultConfig.circle.size, ";\n  ");
}, function (_ref7) {
  var _defaultConfig$$varia, _defaultConfig$$varia2, _defaultConfig$$varia3;
  var $variant = _ref7.$variant,
    $width = _ref7.$width;
  return ($variant === 'rect' || $variant === 'text') && "\n    width: ".concat($width !== null && $width !== void 0 && $width.s ? $width.s : (_defaultConfig$$varia = _config.defaultConfig[$variant].width) === null || _defaultConfig$$varia === void 0 ? void 0 : _defaultConfig$$varia.s, ";\n    @media all and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n        width: ").concat($width !== null && $width !== void 0 && $width.m ? $width.m : ($width === null || $width === void 0 ? void 0 : $width.s) || ((_defaultConfig$$varia2 = _config.defaultConfig[$variant].width) === null || _defaultConfig$$varia2 === void 0 ? void 0 : _defaultConfig$$varia2.s), ";\n      }\n    @media all and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n        width: ").concat($width !== null && $width !== void 0 && $width.l ? $width.l : ($width === null || $width === void 0 ? void 0 : $width.s) || ((_defaultConfig$$varia3 = _config.defaultConfig[$variant].width) === null || _defaultConfig$$varia3 === void 0 ? void 0 : _defaultConfig$$varia3.s), ";\n      }\n  ");
}, function (_ref8) {
  var _ref8$$margin = _ref8.$margin,
    top = _ref8$$margin.top,
    right = _ref8$$margin.right,
    bottom = _ref8$$margin.bottom,
    left = _ref8$$margin.left;
  return "\n      margin-top: ".concat(top ? "var(--spacing-global-".concat(top, ")") : '0', ";\n      margin-bottom: ").concat(bottom ? "var(--spacing-global-".concat(bottom, ")") : '0', ";\n      margin-left: ").concat(left ? "var(--spacing-global-".concat(left, ")") : '0', ";\n      margin-right: ").concat(right ? "var(--spacing-global-".concat(right, ")") : '0', ";\n    ");
}, function (_ref9) {
  var theme = _ref9.theme;
  return "var(--color-global-".concat(theme.animationColor, ")");
});